/* GussKönig PDP – Vanilla JS, keine Abhängigkeiten.
   Funktionen: Varianten-Chips mit Personen-Hinweis, Liefertermin, Größenberater,
   Größe aus dem Berater setzen, technische Daten pro Größe, Add-ons gemeinsam
   mit dem Hauptprodukt in den Warenkorb, Slider-Buttons, Quick-Add. */
(() => {
  if (window.__gkPdp) return;
  window.__gkPdp = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, '').replace(',', '.');
  const mainSection = () => document.querySelector('.shopify-section--main-product');
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let sizeData = null;
  const getSizeData = () => {
    if (sizeData && Object.keys(sizeData).length) return sizeData;
    const el = document.getElementById('gk-size-data');
    try { sizeData = el ? JSON.parse(el.textContent) : {}; } catch (e) { sizeData = {}; }
    return sizeData;
  };

  const refreshCart = () => {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}
  };

  /* 1 – Varianten-Chips: Liter + Personen, Füße mit Einsatzzweck */
  const enhanceChips = () => {
    const sec = mainSection();
    if (!sec) return;
    const data = getSizeData();
    sec.querySelectorAll('label.block-swatch').forEach((label) => {
      if (label.dataset.gkDone) return;
      const span = label.querySelector('span:not(.block-swatch__color)') || label;
      const raw = span.textContent.trim();
      const key = norm(raw);
      let text = '';
      let hint = '';
      let group = '';
      if (data[key]) {
        text = data[key].label;
        hint = data[key].persons + ' Pers.';
        group = 'gk-opt-size';
      } else if (/^mit\s*f/i.test(raw)) {
        text = 'Mit Füßen';
        hint = 'für Glut & Lagerfeuer';
        group = 'gk-opt-feet';
      } else if (/^ohne\s*f/i.test(raw)) {
        text = 'Ohne Füße';
        hint = 'für Grill, Herd & Ofen';
        group = 'gk-opt-feet';
      }
      label.dataset.gkDone = '1';
      label.dataset.gkRaw = raw;
      if (!group) return;
      if (label.parentElement) label.parentElement.classList.add(group);
      span.textContent = text;
      const small = document.createElement('small');
      small.className = 'gk-chip-hint';
      small.textContent = hint;
      label.appendChild(small);
    });

    /* Größenberater-Link neben das Label "Größe" setzen (spart eine Zeile in der Kaufbox) */
    const sizeGroup = sec.querySelector('.gk-opt-size');
    const fieldset = sizeGroup && sizeGroup.closest('fieldset');
    const info = fieldset && fieldset.querySelector('.variant-picker__option-info');
    if (info && !info.querySelector('.gk-size-link')) {
      const link = sec.querySelector('.product-info__block-list .gk-size-link');
      if (link) info.appendChild(link);
    }

    /* Bestseller-Badge: 9 l, nur beim Modell "Mit Füßen" */
    const feetInput = sec.querySelector('.gk-opt-feet input:checked');
    const feetLabel = feetInput && feetInput.id ? sec.querySelector('label[for="' + CSS.escape(feetInput.id) + '"]') : null;
    const withFeet = feetLabel ? /^mit/i.test(feetLabel.dataset.gkRaw || feetLabel.textContent.trim()) : false;
    sec.querySelectorAll('.gk-opt-size label.block-swatch').forEach((l) => {
      const want = withFeet && norm(l.dataset.gkRaw || '') === '9l';
      const badge = l.querySelector('.gk-chip-badge');
      if (want && !badge) {
        const s = document.createElement('span');
        s.className = 'gk-chip-badge';
        s.textContent = 'Bestseller';
        l.appendChild(s);
      } else if (!want && badge) {
        badge.remove();
      }
    });
  };

  /* 1b – Kein Seitensprung beim Variantenwechsel. Prestige scrollt die Galerie per scrollIntoView zum
     Variantenbild. Desktop: gar nicht scrollen (Raster). Mobil: nur das Karussell seitlich bewegen. */
  const desk = window.matchMedia('(min-width: 1000px)');
  const noJump = () => {
    document.querySelectorAll('.shopify-section--main-product .product-gallery__media').forEach((el) => {
      if (el.__gkNoJump) return;
      el.__gkNoJump = true;
      el.scrollIntoView = function () {
        if (desk.matches) return;
        const c = this.closest('scroll-carousel');
        if (!c) return;
        const left = c.scrollLeft + this.getBoundingClientRect().left - c.getBoundingClientRect().left;
        try { c.scrollTo({ left, behavior: reduceMotion() ? 'auto' : 'smooth' }); } catch (e) { c.scrollLeft = left; }
      };
    });
  };

  /* 2 – Liefertermin (Werktage, bundesweite Feiertage ausgenommen) */
  const easter = (y) => {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  };
  const holidayCache = {};
  const holidays = (y) => {
    if (holidayCache[y]) return holidayCache[y];
    const e = easter(y);
    const off = (n) => { const d = new Date(e); d.setDate(d.getDate() + n); return d; };
    const list = [new Date(y, 0, 1), off(-2), off(1), new Date(y, 4, 1), off(39), off(50), new Date(y, 9, 3), new Date(y, 11, 25), new Date(y, 11, 26)];
    holidayCache[y] = new Set(list.map((d) => d.toDateString()));
    return holidayCache[y];
  };
  const isBusinessDay = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays(d.getFullYear()).has(d.toDateString());
  const addBusinessDays = (from, n) => {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) added++; }
    return d;
  };
  const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });

  const renderDelivery = () => {
    document.querySelectorAll('[data-gk-delivery]').forEach((el) => {
      if (el.dataset.gkDone) return;
      el.dataset.gkDone = '1';
      const now = new Date();
      const min = parseInt(el.dataset.min, 10) || 2;
      const max = Math.max(parseInt(el.dataset.max, 10) || min, min);
      const a = addBusinessDays(now, min);
      const b = addBusinessDays(now, max);
      const t = el.querySelector('[data-gk-delivery-text]');
      if (t) t.textContent = min === max ? 'bei dir am ' + fmt.format(a) : 'bei dir zwischen ' + fmt.format(a) + ' und ' + fmt.format(b);
      const cutoff = el.dataset.xmas;
      const xmasEl = el.parentElement && el.parentElement.querySelector('[data-gk-xmas]');
      if (cutoff && xmasEl) {
        const c = new Date(cutoff + 'T23:59:59');
        const start = new Date(now.getFullYear(), 10, 15);
        if (!isNaN(c) && now >= start && now <= c) {
          xmasEl.textContent = 'Rechtzeitig zu Weihnachten, wenn du bis ' + fmt.format(c) + ' bestellst.';
          xmasEl.hidden = false;
        }
      }
    });
  };

  /* 3 – Größe aus dem Berater in der Kaufbox setzen */
  const pickSize = (raw) => {
    const sec = mainSection();
    if (!sec) return;
    const key = norm(raw);
    const label = Array.from(sec.querySelectorAll('label.block-swatch')).find((l) => norm(l.dataset.gkRaw || l.textContent) === key);
    if (!label) return;
    const input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
    if (input && !input.checked) input.click();
    const target = sec.querySelector('[data-block-type="variant-picker"]') || label;
    target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
  };

  /* 4 – Technische Daten & Größentabelle: aktive Größe hervorheben */
  const activeSizeKey = () => {
    const sec = mainSection();
    if (!sec) return null;
    const data = getSizeData();
    let key = null;
    sec.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      const label = input.id ? sec.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      const k = label ? norm(label.dataset.gkRaw || label.textContent) : null;
      if (k && data[k]) key = k;
    });
    return key;
  };
  const syncSizes = () => {
    const key = activeSizeKey();
    if (!key) return;
    document.querySelectorAll('[data-gk-size-key]').forEach((el) => { el.hidden = el.dataset.gkSizeKey !== key; });
    document.querySelectorAll('[data-gk-size-row]').forEach((el) => { el.classList.toggle('is-active', el.dataset.gkSizeRow === key); });
  };

  /* 5 – Add-ons gemeinsam mit dem Hauptprodukt */
  const addonState = new Set();
  const restoreAddons = () => {
    document.querySelectorAll('[data-gk-addon]').forEach((cb) => { cb.checked = addonState.has(cb.value); });
  };
  let pending = null;
  let pendingTimer = null;
  const flushAddons = async () => {
    clearTimeout(pendingTimer);
    if (!pending || !pending.length) return;
    const items = pending.map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
    pending = null;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('add failed');
      addonState.clear();
      restoreAddons();
      refreshCart();
    } catch (e) {}
  };
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.id || form.id.indexOf('product-form-main') !== 0 || !addonState.size) return;
    pending = Array.from(addonState);
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(flushAddons, 1800);
  }, true);
  ['variant:add', 'cart:change'].forEach((name) => {
    document.addEventListener(name, () => { if (pending) setTimeout(flushAddons, 60); });
  });

  /* 6 – Klicks: Dialog, Berater, Slider, Quick-Add */
  document.addEventListener('change', (e) => {
    const cb = e.target.closest && e.target.closest('[data-gk-addon]');
    if (!cb) return;
    if (cb.checked) addonState.add(cb.value); else addonState.delete(cb.value);
  });

  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (!t.closest) return;

    const opener = t.closest('[data-gk-open-size]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') { e.preventDefault(); dialog.showModal(); }
      return;
    }

    if (t.classList && t.classList.contains('gk-dialog')) { t.close(); return; }

    const closer = t.closest('[data-gk-close]');
    if (closer) { const d = closer.closest('dialog'); if (d) d.close(); return; }

    const chip = t.closest('[data-gk-bucket-chip]');
    if (chip) {
      const adv = chip.closest('[data-gk-advisor]');
      if (!adv) return;
      adv.querySelectorAll('[data-gk-bucket-chip]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      adv.querySelectorAll('[data-gk-bucket]').forEach((r) => { r.hidden = r.dataset.gkBucket !== chip.dataset.gkBucketChip; });
      return;
    }

    const pick = t.closest('[data-gk-pick-size]');
    if (pick) {
      e.preventDefault();
      const d = pick.closest('dialog');
      if (d) d.close();
      pickSize(pick.dataset.gkPickSize);
      return;
    }

    const railBtn = t.closest('[data-gk-rail-btn]');
    if (railBtn) {
      const rail = document.getElementById(railBtn.getAttribute('aria-controls'));
      if (!rail) return;
      const card = rail.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: railBtn.dataset.gkRailBtn === 'next' ? step : -step, behavior: reduceMotion() ? 'auto' : 'smooth' });
      return;
    }

    const quick = t.closest('[data-gk-quick-add]');
    if (quick) {
      e.preventDefault();
      const original = quick.textContent;
      quick.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(quick.dataset.gkQuickAdd, 10), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        quick.textContent = 'Im Warenkorb';
        refreshCart();
      } catch (err) {
        quick.textContent = 'Nochmal versuchen';
      } finally {
        quick.removeAttribute('aria-busy');
        setTimeout(() => { quick.textContent = original; }, 2500);
      }
    }
  });

  /* 7 – Technische Daten: auf Mobile zugeklappt starten */
  const initSpecs = () => {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    document.querySelectorAll('[data-gk-mobile-closed]').forEach((d) => {
      if (d.dataset.gkInit) return;
      d.dataset.gkInit = '1';
      d.open = false;
    });
  };

  const run = () => { noJump(); enhanceChips(); renderDelivery(); restoreAddons(); syncSizes(); initSpecs(); };
  window.gkPdpRun = run;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  /* Prestige ersetzt beim Variantenwechsel Teile der Kaufbox – danach erneut anwenden */
  let raf = 0;
  const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(run); };
  const observe = () => { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
  document.addEventListener('change', (e) => { if (e.target && e.target.matches && e.target.matches('.shopify-section--main-product input[type="radio"]')) setTimeout(run, 400); });
})();
